import Ajax from '../common/ajax'
import Tool from '../common/tool'

export default {
  model: 'room',
  getList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/list`, queryParam)
  },
  add (data = {}) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/addOrUpdate`, data)
  },
  edit (data = {}) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/add`, data)
  },
  allot (id) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/allot/${id}`)
  },
  getImportExamAllot (param) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/importEvaluateAllot`, param)
  },
  del (id) {
    return Ajax.del(`/api/gradeEvaluation/v1/${this.model}/delete/${id}`)
  },
  updateRoom (param) {
    return Ajax.put(`/api/gradeEvaluation/v1/${this.model}/update`, param)
  },
  getDetail (id) {
    return Ajax.get(`/api/gradeEvaluation/v1/${this.model}/detail/${id}`)
  },
  async getAgentTreeData (id) {
    let agentList = await Ajax.get(`/api/gradeEvaluation/v1/${this.model}/listAgent/${id}`)
    let set1 = new Set()
    let set2 = new Set()
    let listAll = []
    for (let i in agentList) {
      let agent = agentList[i]
      if (!set1.has(agent.parentAddress)) {
        listAll.push({ value: agent.parentAddress, label: agent.parentAddressInfo, parentId: null })
        set1.add(agent.parentAddress)
      }
      if (!set2.has(agent.address)) {
        listAll.push({ value: agent.address, label: agent.addressInfo, parentId: agent.parentAddress })
        set2.add(agent.address)
      }
      listAll.push({ value: agent.agentId, label: agent.agentName, parentId: agent.address })
    }
    let tree = Tool.toTree(listAll, 'value', 'parentId', null, 'children')
    return tree
  },
  async getGradeTreeData (batchId) {
    let gradeList = await Ajax.post(`/api/gradeEvaluation/v1/${this.model}/listGrade/${batchId}`)
    let set1 = new Set()
    let set2 = new Set()
    let listAll = []
    for (let i in gradeList) {
      let grade = gradeList[i]
      if (!set1.has(grade.categoryId)) {
        listAll.push({ value: grade.categoryId, label: grade.categoryName, parentId: null })
        set1.add(grade.categoryId)
      }
      if (!set2.has(grade.specialtyId)) {
        listAll.push({ value: grade.specialtyId, label: grade.specialtyName, parentId: grade.categoryId })
        set2.add(grade.specialtyId)
      }
      listAll.push({ value: grade.gradeId, label: grade.gradeName, parentId: grade.specialtyId })
    }
    let tree = Tool.toTree(listAll, 'value', 'parentId', null, 'children')
    return tree
  }
}
